import { render, staticRenderFns } from "./Message-item.vue?vue&type=template&id=69db8158&scoped=true"
import script from "./Message-item.vue?vue&type=script&lang=js"
export * from "./Message-item.vue?vue&type=script&lang=js"
import style0 from "./Message-item.vue?vue&type=style&index=0&id=69db8158&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69db8158",
  null
  
)

export default component.exports